import { isAuthenticatedCustomer } from '@ori/auth';
import { useToken } from '@ori/favorites-hooks';
import { useEffect } from 'react';

import type { useFavorites } from './useFavorites';
import { dispatchFavoritesUpdatedEvent } from '../utils';

export const useLoadedEvent = (favorites: ReturnType<typeof useFavorites>['favorites']) => {
  const { customerId } = useToken();
  useEffect(() => {
    const onLoaded = () => {
      if (isAuthenticatedCustomer(customerId)) {
        dispatchFavoritesUpdatedEvent({ favorites, lastUpdated: null });
      }
    };
    const timeout = setTimeout(onLoaded);

    return () => clearTimeout(timeout);
  }, [customerId, favorites]);
};
